import { List } from '@apollo/space-kit/List';
import { Select } from '@apollo/space-kit/Select';
import classnames from 'classnames';
import moment, { MomentInput } from 'moment';
import React from 'react';

interface Launch {
  id: string;
  shortenedID: string;
  createdAt: MomentInput;
}

interface Props {
  name: string;
  disabled?: boolean;
  launches: Launch[];
  currentTimestamp: MomentInput;
  launchId: string;
  onChange?: (launchId: string) => void;
}

export const LaunchSelect = ({
  name,
  disabled,
  launches,
  currentTimestamp,
  launchId,
  onChange,
}: Props) => {
  const launchesById: { [key: string]: Launch } = Object.create(null);
  launches.forEach((launch) => {
    launchesById[launch.id] = launch;
  });

  return (
    <div className="flex items-center rounded border border-silver bg-silver-lighter px-3 py-2">
      <div className="mr-4 flex-none text-sm font-semibold text-neutral">
        {name}
      </div>
      <div className="flex-none">
        <Select
          value={launchId}
          onChange={(event) => {
            onChange?.(event.target.value);
          }}
          disabled={disabled}
          size="standard"
          listAs={<List className="w-52 p-2.5" />}
          renderTriggerNode={(props) => (
            <div
              className={classnames(
                disabled ? 'text-secondary' : 'text-neutral',
              )}
            >
              {(props?.value
                ? launchesById[props.value as string]?.shortenedID
                : null) ?? 'Select launch ID'}
            </div>
          )}
        >
          <optgroup label="Launch ID">
            {launches.map((launch) => {
              return (
                <option key={launch.id} value={launch.id}>
                  <div className="flex items-center">
                    <div
                      className={classnames(
                        'flex-none',
                        launchId === launch.id
                          ? 'font-semibold'
                          : 'font-normal',
                      )}
                    >
                      {launch.shortenedID}
                    </div>
                    <div className="ml-auto flex-none text-secondary">
                      {moment(launch.createdAt).from(currentTimestamp)}
                    </div>
                  </div>
                </option>
              );
            })}
          </optgroup>
        </Select>
      </div>
    </div>
  );
};
